import { takeLatest, call, put } from 'redux-saga/effects';
import axios from 'axios';
import { getBlogsSuccess, getBlogsFailure ,getSingleBlogSuccess,getSingleBlogFailure} from '../slice/blogSlice';
const url =process.env.REACT_APP_API_URL;
function* fetchBlogs(action) {
  try {
    const response = yield call(() => axios.get(`${url}/getBlogs?page=${action.payload.page}&limit=${action.payload.limit}`));
    yield put(getBlogsSuccess(response.data.data));
  } catch (error) {
    yield put(getBlogsFailure(error.message));
  }
}
function* fetchSingleBlog(action) {
  try {
    const response = yield call(() => axios.get(`${url}/getSingleBlog?blogId=${action.payload}`));
    yield put(getSingleBlogSuccess(response.data.data));
  } catch (error) {
    yield put(getSingleBlogFailure(error.message));
  }
}

export function* watchGetBlogs() {
  yield takeLatest('blog/getBlogs', fetchBlogs);
}
export function* watchGetSingleBlog() {
  yield takeLatest('blog/getSingleBlog', fetchSingleBlog);
}
